<template>
  <div class="wi-100x pr iconSvg3">
    <svg x="0px" y="0px" viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve">
      <circle id="iconSvg3-circle1" fill="#E94520" cx="78.2" cy="121.7" r="58.3" />
      <circle id="iconSvg3-circle2" fill="none" stroke-dasharray="4" stroke="#FFFFFF" stroke-width="1" stroke-miterlimit="10" cx="120.5" cy="79.5" r="58.3" />
      <line id="iconSvg3-line1" fill="none" stroke="#FFFFFF" stroke-width="1" stroke-miterlimit="10" x1="83.9" y1="91" x2="134.1" y2="41" />
      <line id="iconSvg3-line2" fill="none" stroke="#FFFFFF" stroke-width="1" stroke-miterlimit="10" x1="78.9" y1="139.4" x2="38.2" y2="180" />
      <rect id="iconSvg3-rect" x="113.8" y="85.5" fill="#FFFFFF" width="29.1" height="29.1" />
    </svg>
  </div>
</template>
<script>
export default {
  name: 'iconSvg3',
  methods: {
    animation () {
      setTimeout(() => {
        var anime = this.$anime
        var rect = anime.timeline({
          duration: 3000,
          easing: 'easeInSine',
          loop: true
        })
        rect.add({
          targets: '#iconSvg3-rect',
          translateX: [0, 10]
        }).add({
          targets: '#iconSvg3-rect',
          translateX: [10, 0]
        })
        var circ = anime.timeline({
          duration: 10000,
          easing: 'cubicBezier(0.840, 0.135, 0.210, 0.935)',
          loop: true
        })
        circ.add({
          targets: '#iconSvg3-circle2',
          strokeDasharray: [4, 8]
        }).add({
          targets: '#iconSvg3-circle2',
          strokeDasharray: [8, 4]
        })
        var line1 = anime.timeline({
          duration: 2000,
          easing: 'cubicBezier(0.840, 0.135, 0.210, 0.935)',
          loop: true
        })
        line1.add({
          delay: 3000,
          targets: '#iconSvg3-line1',
          strokeDashoffset: 72
        }).add({
          delay: 1000,
          targets: '#iconSvg3-line1',
          strokeDashoffset: 0
        })
        var line2 = anime.timeline({
          duration: 2000,
          easing: 'cubicBezier(0.840, 0.135, 0.210, 0.935)',
          loop: true
        })
        line2.add({
          delay: 3000,
          targets: '#iconSvg3-line2',
          strokeDashoffset: 58
        }).add({
          delay: 1000,
          targets: '#iconSvg3-line2',
          strokeDashoffset: 0
        })
      }, 500)
    }
  },
  mounted () {
    this.animation()
  }
}
</script>
<style scoped>
  .iconSvg3 {
    position: relative;
    margin-bottom: 20px;
    width: 100px;
    left: -10px;
  }
  .iconSvg3 svg {
    width: 100%;
  }
  #iconSvg3-rect {
    transform-origin: center;
  }
  #iconSvg3-line1 {
    stroke-dasharray: 72;
    stroke-dashoffset: 0;
  }
  #iconSvg3-line2 {
    stroke-dasharray: 58;
    stroke-dashoffset: 0;
  }
  @media screen and (min-width: 1200px) and (max-width: 1920px) {
    .iconSvg3 {
      width: 100px;
      left: -10px;
    }
  }

  @media screen and (min-width: 1920px) {
    .iconSvg3 {
      width: 120px;
      left: -12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/compos/iconSvg3.vue